import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { useSite } from "@/context/SiteContext";
import { RECEPISSES } from "@/lib/content";
import { PageHero } from "@/components/kit";

function H({ children }) {
  return <h2 className="mt-10 font-display text-2xl font-bold uppercase text-ink">{children}</h2>;
}

export default function Legal({ kind }) {
  const privacy = kind === "privacy";
  useSeo(privacy ? "Politique de confidentialité" : "Mentions légales");
  const { settings } = useSite();
  const c = settings?.contacts || {};
  return (
    <div data-testid={privacy ? "privacy-page" : "legal-page"}>
      <PageHero eyebrow="Informations" title={privacy ? "Politique de confidentialité" : "Mentions légales"} />
      <div className="container-x max-w-3xl py-12 leading-relaxed text-neutral-800">
        {privacy ? (
          <>
            <H>Responsables du traitement</H>
            <p>ONG MA LEBA ({c.ong?.email}) et ASSOCIATION MA LEBA ({c.association?.email}), Makana, République du Congo.</p>
            <H>Données collectées</H>
            <p>Via les formulaires du site : nom, e-mail, téléphone, pays, structure concernée, objet et contenu de votre message, ainsi que les informations propres à chaque demande (partenariat, bénévolat, formation, don, livre d'or, newsletter). <strong>Aucune donnée médicale n'est collectée via le site.</strong></p>
            <H>Finalités</H>
            <p>Répondre à vos demandes, gérer les candidatures et inscriptions, publier les messages du livre d'or après modération et envoyer la newsletter aux personnes inscrites.</p>
            <H>Base légale et consentement</H>
            <p>Votre consentement explicite, recueilli par une case à cocher sur chaque formulaire.</p>
            <H>Durée de conservation</H>
            <p>[Texte à compléter : durée de conservation des données]</p>
            <H>Vos droits</H>
            <p>Vous pouvez demander l'accès, la rectification ou la suppression de vos données, ou vous désinscrire de la newsletter, en nous écrivant via la page <Link to="/contact" className="text-u underline">Contact</Link>.</p>
          </>
        ) : (
          <>
            <H>Éditeurs du site</H>
            <p><strong>ONG MA LEBA</strong> — Organisation Non Gouvernementale Humanitaire et Développement. {RECEPISSES.ong}.</p>
            <p className="mt-3"><strong>ASSOCIATION MA LEBA (A.M.L)</strong> — {RECEPISSES.association}.</p>
            <H>Directrice de la publication</H>
            <p>{settings?.president || "Mme LE DOUAIRON née MIANTOURILA Prisca Aubierge"}, Présidente.</p>
            <H>Contact</H>
            <p>{c.ong?.email} · {c.association?.email}</p>
            <H>Hébergement</H>
            <p>[Texte à compléter : nom et adresse de l'hébergeur]</p>
            <H>Propriété intellectuelle</H>
            <p>Les logos, textes et photographies sont la propriété de MA LEBA ou de leurs auteurs. Toute reproduction sans autorisation est interdite.</p>
          </>
        )}
      </div>
    </div>
  );
}
